import { FormlyFieldConfig } from '@ngx-formly/core';

export class OfferFormFields {

  offerFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'offer-row',
      fieldGroup: [
        {
          className: 'offer-column-left',
          fieldGroup: [
            {
              key: 'amount',
              type: 'currency',
              templateOptions: {
                label: 'Amount',
                attributes: {
                  'data-cy': 'offer-amount-input'
                },
              },
            },
            {
              key: 'payback',
              type: 'currency',
              templateOptions: {
                label: 'Payback',
                attributes: {
                  'data-cy': 'offer-payback-input'
                },
              },
            },
            {
              fieldGroupClassName: 'cost-row',
              fieldGroup: [
                {
                  className: 'cost-column-type',
                  fieldGroup: [
                    {
                      key: 'costType',
                      type: 'select',
                      templateOptions: {
                        label: 'Cost Type',
                        options: [
                          { value: 'apr', label: 'APR' },
                          { value: 'factor', label: 'Factor' },
                          { value: 'interestRate', label: 'Interest' },
                        ],
                        attributes: {
                          'data-cy': 'offer-cost-type-input'
                        },
                      }
                    }
                  ]
                },
                {
                  className: 'cost-column-amount',
                  fieldGroup: [
                    {
                      key: 'cost',
                      type: 'number',
                      templateOptions: {
                        label: 'Cost',
                        ngxMask: {
                          suffix: ' %'
                        },
                        attributes: {
                          'data-cy': 'offer-cost-input'
                        },
                      },
                      expressionProperties: {
                        'templateOptions.ngxMask.suffix': (model: any) =>
                          model.costType === 'apr' || model.costType === 'interestRate' ? ' %' : '',
                      }
                    }
                  ]
                }
              ]
            },
            {
              key: 'commission',
              type: 'currency',
              templateOptions: {
                label: 'Commission',
                attributes: {
                  'data-cy': 'offer-commission-input'
                },
              }
            },
            {
              key: 'points',
              type: 'number',
              templateOptions: {
                label: 'Points',
                ngxMask: {
                  suffix: ' pts.'
                },
                attributes: {
                  'data-cy': 'offer-points-input'
                },
              }
            },
            {
              key: 'numPayments',
              type: 'number',
              templateOptions: {
                label: 'Number of Payments',
                attributes: {
                  'data-cy': 'offer-num-payments-input'
                },
              }
            },
            {
              key: 'paymentFrequency',
              type: 'select',
              templateOptions: {
                label: 'Payment Frequency',
                attributes: {
                  'data-cy': 'offer-payment-frequency-input'
                },
                options: [
                  { label: 'Daily', value: 'daily' },
                  { label: 'Semi-Weekly', value: 'semiweekly' },
                  { label: 'Weekly', value: 'weekly' },
                  { label: 'Bi-Weekly', value: 'biweekly' },
                  { label: 'Semi-Monthly', value: 'semimonthly' },
                  { label: 'Monthly', value: 'monthly' },
                  { label: 'Bi-Monthly', value: 'bimonthly' }
                ]
              }
            },
            {
              key: 'netFundedAmount',
              type: 'currency',
              templateOptions: {
                label: 'Net Funded Amount',
                attributes: {
                  'data-cy': 'offer-net-funded-amount-input'
                },
              }
            },
          ]
        },
        {
          className: 'offer-column-right',
          fieldGroup: [
            {
              key: 'paymentAmount',
              type: 'currency',
              templateOptions: {
                label: 'Payment Amount',
                attributes: {
                  'data-cy': 'offer-payment-amount-input'
                },
              }
            },
            {
              key: 'term',
              type: 'number',
              templateOptions: {
                label: 'Term',
                ngxMask: {
                  suffix: ' mo.'
                },
                attributes: {
                  'data-cy': 'offer-term-input'
                },
              }
            },
            {
              key: 'originationFee',
              type: 'number',
              templateOptions: {
                label: 'Origination Fee',
                ngxMask: {
                  suffix: ' %'
                },
                attributes: {
                  'data-cy': 'offer-origination-fee-input'
                },
              }
            },
            {
              key: 'position',
              type: 'number',
              templateOptions: {
                label: 'Position',
                attributes: {
                  'data-cy': 'offer-position-input'
                },
              }
            },
            {
              key: 'type',
              type: 'select',
              templateOptions: {
                label: 'Offer Type',
                options: [
                  { label: 'Hard', value: 'hard' },
                  { label: 'Soft', value: 'soft' },
                  { label: 'Prequalified', value: 'prequal' },
                  { label: 'Referral', value: 'referral' }
                ],
                attributes: {
                  'data-cy': 'offer-type-input'
                },
              }
            },
            {
              key: 'received',
              type: 'datepicker',
              defaultValue: new Date(),
              templateOptions: {
                label: 'Date Received',
                attributes: {
                  'data-cy': 'offer-received-input'
                },
              }
            },
            {
              key: 'expiration',
              type: 'datepicker',
              templateOptions: {
                label: 'Expiration Date',
                attributes: {
                  'data-cy': 'offer-expiration-input'
                },
              }
            },
            {
              key: 'offerLink',
              type: 'text',
              templateOptions: {
                label: 'Offer Link',
                attributes: {
                  'data-cy': 'offer-link-input'
                },
              },
              validators: {
                validation: ['url'],
              },
            }
          ],
        },
      ]
    },
    {
      fieldGroupClassName: 'offer-notes-row',
      fieldGroup: [
        {
          className: 'offer-column-full',
          fieldGroup: [
            {
              key: 'notes',
              type: 'textarea',
              templateOptions: {
                label: 'Notes',
                rows: 4,
                attributes: {
                  'data-cy': 'offer-notes-input'
                },
              }
            }
          ]
        }
      ]
    }
  ];

  factoringFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'offer-row',
      fieldGroup: [
        {
          className: 'offer-column-left',
          fieldGroup: [
            {
              key: 'amount',
              type: 'currency',
              templateOptions: {
                label: 'Facility Amount',
                attributes: {
                  'data-cy': 'offer-amount-input'
                },
              },
            },
            {
              key: 'advanceRate',
              type: 'number',
              templateOptions: {
                label: 'Advance Rate',
                ngxMask: {
                  suffix: ' %'
                },
                min: 20,
                max: 99,
                attributes: {
                  'data-cy': 'offer-advance-rate-input'
                },
              },
            },
            {
              key: 'minPurchaseFee',
              type: 'number',
              templateOptions: {
                label: 'Min Purchase Fee',
                ngxMask: {
                  suffix: ' %'
                },
                attributes: {
                  'data-cy': 'offer-min-purchase-fee-input'
                },
                min: 0,
                max: 99
              },
            },
            {
              key: 'commission',
              type: 'currency',
              templateOptions: {
                label: 'Commission',
                attributes: {
                  'data-cy': 'offer-commission-input'
                },
              }
            },
            {
              key: 'points',
              type: 'number',
              templateOptions: {
                label: 'Points',
                ngxMask: {
                  suffix: ' pts.'
                },
                attributes: {
                  'data-cy': 'offer-points-input'
                },
              }
            },
            {
              key: 'paymentTerm',
              type: 'select',
              templateOptions: {
                label: 'Payment Term',
                options: [
                  { label: 'Net 15', value: 'net 15' },
                  { label: 'Net 30', value: 'net 30' },
                  { label: 'Net 40', value: 'net 40' },
                  { label: 'Net 50', value: 'net 50' },
                  { label: 'Net 60', value: 'net 60' },
                  { label: 'Net 70', value: 'net 70' },
                  { label: 'Net 80', value: 'net 80' },
                  { label: 'Net 90', value: 'net 90' },
                  { label: 'Net 90+', value: 'net 90+' }
                ],
                attributes: {
                  'data-cy': 'offer-payment-term-input'
                },
              }
            }
          ]
        },
        {
          className: 'offer-column-right',
          fieldGroup: [
            {
              key: 'originationFee',
              type: 'number',
              templateOptions: {
                label: 'Origination Fee',
                ngxMask: {
                  suffix: ' %'
                },
                attributes: {
                  'data-cy': 'offer-origination-fee-input'
                },
              }
            },
            {
              key: 'position',
              type: 'number',
              templateOptions: {
                label: 'Position',
                attributes: {
                  'data-cy': 'offer-position-input'
                },
              }
            },
            {
              key: 'term',
              type: 'number',
              templateOptions: {
                label: 'Contract Duration',
                ngxMask: {
                  suffix: ' mo.'
                },
                attributes: {
                  'data-cy': 'offer-term-input'
                },
              }
            },
            {
              key: 'received',
              type: 'datepicker',
              defaultValue: new Date(),
              templateOptions: {
                label: 'Date Received',
                attributes: {
                  'data-cy': 'offer-received-input'
                },
              }
            },
            {
              key: 'expiration',
              type: 'datepicker',
              templateOptions: {
                label: 'Expiration Date',
                attributes: {
                  'data-cy': 'offer-expiration-input'
                },
              }
            },
            {
              key: 'netFundedAmount',
              type: 'currency',
              templateOptions: {
                label: 'Net Funded Amount',
                attributes: {
                  'data-cy': 'offer-net-funded-amount-input'
                },
              }
            },
          ]
        }
      ]
    },
    {
      fieldGroupClassName: 'offer-notes-row',
      fieldGroup: [
        {
          className: 'offer-column-full',
          fieldGroup: [
            {
              key: 'offerLink',
              type: 'text',
              templateOptions: {
                label: 'Offer Link',
                attributes: {
                  'data-cy': 'offer-link-input'
                },
              },
              validators: {
                validation: ['url'],
              },
            }
          ]
        }
      ]
    },
    {
      fieldGroupClassName: 'offer-notes-row',
      fieldGroup: [
        {
          className: 'offer-column-full',
          fieldGroup: [
            {
              key: 'notes',
              type: 'textarea',
              templateOptions: {
                label: 'Notes',
                rows: 4,
                attributes: {
                  'data-cy': 'offer-notes-input'
                },
              }
            }
          ]
        }
      ]
    },
  ];

  constructor() { }

  get getOfferFields() {
    return this.offerFields;
  }

  get getFactoringFields() {
    return this.factoringFields;
  }
}
